<div class="page-head-section">
  <p>Internal Complaint Committee (ICC)</p>
</div>

<div class="Committees">
  <div [innerHTML]="HtmlData"></div>
</div>


